// Works out how an integration is doing from its status and its latest runs.
// key: failing | stale | new | running | ok | paused  (what the filters and dashboard group by)

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

const LEVEL_ORDER = { ok: 0, info: 1, warn: 2, error: 3 };

export function getHealth(integration, now = Date.now()) {
  const lastRun = integration.runs && integration.runs[0];
  const lastRunAt = lastRun ? new Date(lastRun.createdAt).getTime() : null;
  const errorCount = lastRun && lastRun._count ? lastRun._count.errorLogs : 0;

  if (integration.status === 'paused' || integration.status === 'rejected') {
    return { key: 'paused', level: 'ok', reasons: [integration.status === 'paused' ? 'Paused' : 'Rejected'], lastRun };
  }

  let level = 'ok';
  const reasons = [];
  const raise = (next) => {
    if (LEVEL_ORDER[next] > LEVEL_ORDER[level]) level = next;
  };

  if (integration.status === 'new') {
    reasons.push('Awaiting approval');
    raise('info');
  }

  if (integration.scraperFileFound === false) {
    reasons.push('Scraper file not found');
    raise('error');
  }

  let running = false;
  if (lastRun && lastRun.status === 'start') {
    if (now - lastRunAt > 30 * MINUTE) {
      reasons.push('Last run looks stuck');
      raise('error');
    } else {
      running = true;
      reasons.push('Running now');
      raise('info');
    }
  } else if (errorCount > 0) {
    reasons.push(`Last run had ${errorCount} error${errorCount > 1 ? 's' : ''}`);
    raise('error');
  }

  if (integration.status === 'active') {
    if (!lastRun) {
      reasons.push('Never run');
      raise('warn');
    } else if (!running) {
      const allowed = integration.frequency === 'weekly' ? 8 * DAY : 2 * DAY;
      if (now - lastRunAt > allowed) {
        reasons.push(`No run in ${Math.round((now - lastRunAt) / DAY)} days`);
        raise('warn');
      }
    }
  }

  let key = 'ok';
  if (integration.status === 'new') key = 'new';
  else if (level === 'error') key = 'failing';
  else if (level === 'warn') key = 'stale';
  else if (running) key = 'running';

  return { key, level, reasons, lastRun };
}

export const HEALTH_LABELS = {
  failing: 'Failing',
  stale: 'Stale',
  new: 'New',
  running: 'Running',
  ok: 'Healthy',
  paused: 'Paused',
};

export const HEALTH_COLORS = {
  failing: 'red',
  stale: 'amber',
  new: 'orange',
  running: 'blue',
  ok: 'green',
  paused: 'gray',
};

// Lower sorts first: problems at the top
export const HEALTH_PRIORITY = { failing: 0, stale: 1, new: 2, running: 3, ok: 4, paused: 5 };
